import 'select2'

$.fn.select2.defaults.set( "theme", "bootstrap4" );
